import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehaviorService } from '../_services/behavior.service';
import { LoginService } from '../_services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private beh: BehaviorService,
    private loginSvc: LoginService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let user = JSON.parse(localStorage.u || '{}');

    if (user.j) {
      return this.loginSvc.loadUserAccountInfo().pipe(map(user => {
        !(!!user?.account?.id) && setTimeout(() => { this.beh.popup.next({ pop: 'access-account' }) }, 300);
        return !!user?.account?.id ? true : false;
      }));
    } else { return false }
  }

}
